<template>
  <PopularMarketplaces>
    <template #filters>
      <MarketplacesWrapper>
        <PopularMarketplacesTable />
      </MarketplacesWrapper>
    </template>
  </PopularMarketplaces>
</template>

<script setup lang="ts">
import MarketplacesWrapper from '@/modules/keywords/components/organisms/MarketplacesWrapper';
import PopularMarketplacesTable from '@/modules/keywords/components/organisms/PopularMarketplacesTable';
import PopularMarketplaces from '@/modules/keywords/components/templates/PopularMarketplaces';
</script>


